const initialState = {
  sizes: {
    app: {
      width: 930
    }
  }
}

export const moduleName = 'ui'
export const UPDATE_ELEMENT_SIZE = `${moduleName}/UPDATE_ELEMENT_SIZE`

export default function reducer(state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case UPDATE_ELEMENT_SIZE:
      return { ...state, sizes: { ...state.sizes, ...payload } }

    default:
      return state
  }
}

export function updateElementSize(element, size) {
  return {
    type: UPDATE_ELEMENT_SIZE,
    payload: { [element]: size }
  }
}
